import React from 'react';

const ConfirmDelete = ({ open, onClose, onConfirm, title, message }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 animate-fadeIn">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md animate-slideUp">
        <h3 className="text-2xl font-extrabold text-red-600 mb-4 text-center tracking-tight drop-shadow">{title}</h3>
        <p className="text-gray-700 mb-8 text-center text-lg font-medium">{message}</p>
        <div className="flex justify-center gap-4 mt-6">
          <button
            className="px-6 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300 font-semibold transition-all duration-200 shadow"
            onClick={onClose}
          >No</button>
          <button
            className="px-6 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 font-bold shadow-lg transition-all duration-200"
            onClick={onConfirm}
          >Yes, Delete</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDelete;
